import { render, staticRenderFns } from "./AddPurchaseInvoiceLinesModalFrame.vue?vue&type=template&id=88351272&scoped=true&"
import script from "./AddPurchaseInvoiceLinesModalFrame.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseInvoiceLinesModalFrame.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchaseInvoiceLinesModalFrame.vue?vue&type=style&index=0&id=88351272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88351272",
  null
  
)

export default component.exports